'use strict'
import '@babel/polyfill';
import'intersection-observer';
import main from "./scripts/main.js";

import "./scripts/polyfills/requestAnimationFrame";
import smoothscroll from 'smoothscroll-polyfill';
import './scripts/polyfills/forEach';
import './scripts/polyfills/remove';

// kick off the polyfill!
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

//import smoothScrolling from "./scripts/polyfills/scrollSmooth.js"

// console.log("JS : entry point")

main.init()



  


// WEBPACK FOOTER //
// ./src/app.js